import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

import { createGlobalStyle } from 'styled-components';

export const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: 'Amplesoft';
    src: url('https://procura.apolar.com.br/fonts/AmpleSoftPro-Bold.woff2') format('woff2');
    font-weight: bold;
    font-style: normal;
  }
`;

export const Wrapper = styled.div`
  background: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Product Sans', sans-serif; /* Fonte padrão aplicada aqui */
`;

export const Content = styled.div`
  font-family: 'Product Sans', sans-serif; /* Fonte padrão aplicada aqui */
  position: absolute;
  top: 15%;

  img {
    background: var(--white);
    width: 100px;
  }
  
  .login-page{
    font-family: 'Amplesoft';
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      padding: 10px 0;
      color: var(--blueDark);
    }

    h4 {
      padding: 20px 0;
    }

    input {
      width: 80%;
      border: 1px solid var(--gray);
      border-radius: 10px;
      height: 50px;
      padding: 0 15px;
      margin: 10px 0 10px 0;
      color: var(--black);
      font-family: 'Product Sans', sans-serif; /* Garantindo a fonte no input */

      &::placeholder {
        color: var(--gray);
      }
    }

    button {
      margin: 20px 0 30px 0;
      height: 25px;
      background: var(--yellowDark);
      width: 30%;
      color: var(--blueDark);
      border: 0;
      border-radius: 7px;
      font-size: 14px;
      font-weight: bold;
      transition: background 0.2s;
      box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);
      font-family: 'Product Sans', sans-serif; /* Garantindo a fonte no botão */

      &:hover {
        background: ${darken(0.06, '#f7c325')};
      }
    }

    a {
      color: var(--white);
      margin-top: 15px;
      font-size: 16px;
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }

    strong {
      display: flex;
      flex: 1;
      justify-content: flex-start;
      align-items: flex-start;
    }

    strong.label {
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      align-self: flex-start;
    }

    div.email {
      font-size: 15px;
      margin: 20px 0px 10px;
      font-weight: bold;
    }

    div.infoEmail {
      font-size: 13px;
      margin: 0px 0px 15px 0px;
    }

    div.inputName {
      width: 100%;
      height: 75px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0px;
    }

    div.cpf {
      font-size: 16px;
      margin-bottom: 10px;
    }

    div.inputPassword {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0px;
    }

    div.buttons {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      flex-wrap: wrap;
    }

    .buttons button {
      margin: 0;
      height: 40px;
      width: 100%;
      
    }

    div.buttons #forgetPassword {
      color: var(--blueDark);
      font-size: 14px;
      font-weight: bold;
    }

    div.infoForgetPassword {
      font-size: 0.8rem;
    }

    
    .inputForgetPassword {
      width: 100% !important;
    }


    button.buttonForgetPassword {
      width: 100%;
      height: 40px;
      margin-top: 10px;
    }

    div.info {
      width: 280px;
      font-size: 12px;
      font-weight: bold;
      margin: 25px;
    }

    div.message {
      font-size: 15px;
      font-weight: bold;
      color: var(--blueDark);
    }

    div.infoForget {
      width: 280px;
      font-size: 15px;
      font-weight: bold;
      margin: 25px;
      color: var(--blueDark);
    }

    h5 {
      padding: 20px 0;
    }

    span {
      color: var(--salmon);
      align-self: center;
      margin: 0 0 10px;
      font-weight: bold;
      font-size: 14px;
    }
  }
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayDark);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;

export const MobileLayout = styled.div`

  /* === ESTILOS GLOBAIS === */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  overflow-y: auto; 

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; 
  background-color: #fcfcfc;
  
  background-image: url(${props => props.bgDesktop});
  background-position: bottom center;
  background-size: cover;
  background-repeat: no-repeat;
  
  font-family: 'Product Sans', sans-serif;
  
  /* Empurra o conteúdo um pouco para cima para não cobrir a tartaruga */
  padding-bottom: 10vh; 

  .top-section-container {
      position: absolute;
      top: 15%;
  }

  .title-desktop {
    display: none; 
  }

  .title, .subtitle {
    display: block;
  }
  
  .btn-proximo, .btn-indicar {
    border: 2px solid #2b1b54 !important;
    font-weight: bold;
  }

  .logo-mobile {
    display: block;
    width: 35px; 
    margin-bottom: 15px;
  }

  .top-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    text-align: center;
    width: 100%;
    
    /* Move todo o bloco centralizado um pouco para cima */
    margin-top: -8vh;

    .logo {
      display: none;
    }

    .title {
      font-family: 'Amplesoft'; 
      color: #2b1b54;
      font-size: 26px;
      font-weight: 800;
      margin: 0 0 5px 0;
    }

    .subtitle {
      color: #2b1b54;
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 10px 0;
    }

    .instruction {
      color: #000000;
      font-size: 17px;
      margin: 0 0 5px 0;
    }

    form {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 320px;
      margin: 0 auto; 

      input {
        height: 45px;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 0 15px;
        font-size: 14px;
        margin-bottom: 20px;
        background: rgba(255,255,255,0.8);
        font-family: 'Product Sans', sans-serif;
        
        &::placeholder {
          color: #999;
        }
      }

      span {
        color: #e74c3c;
        font-size: 12px;
        margin-top: -15px;
        margin-bottom: 15px;
      }

      .btn-proximo {
        background-color: #fcc919;
        color: #2b1b54;
        font-weight: bold;
        font-size: 16px;
        border: none;
        border-radius: 15px;
        height: 45px;
        width: 100%;
        max-width: 200px;
        margin: 0 auto;
        cursor: pointer;
        transition: filter 0.2s;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1); 
        font-family: 'Product Sans', sans-serif;

        &:hover {
          filter: brightness(0.9);
        }
      }
    }
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 0;
    text-align: center;
    margin-top: 15px;
    width: 100%;

    .ambassador-title {
      color: #2b1b54;
      font-size: 24px;
      font-weight: 800;
      margin: 0 0 10px 0;
      line-height: 1.2;
    }

    .ambassador-subtitle {
      color: #222;
      font-size: 17px;
      margin: 0 0 20px 0;
    }

    .btn-indicar {
      background-color: #fcc919;
      color: #2b1b54;
      font-weight: bold;
      font-size: 16px;
      border: none;
      border-radius: 15px;
      height: 45px;
      padding: 0 30px;
      cursor: pointer;
      transition: filter 0.2s;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      font-family: 'Product Sans', sans-serif;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }

  /* === TROCA DE BACKGROUND PARA MOBILE === */
  @media (max-width: 768px) {
    background-image: url(${props => props.bgMobile});
    background-position: bottom center;
  }
`;